module.exports = __webpack_public_path__ + "static/media/avatar-9.1de9dd27.png";